import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {PortfolioService, portfolioTypes} from "../portfolio.service";
import {Router} from "@angular/router";
import {PortfolioModel, VISIBILITY_SHARED} from "../../../shared/models/portfolio.model";
import {animate, state, style, transition, trigger} from "@angular/animations";
import moment from "moment";
import { InfoPopoverComponent } from "src/app/components/info-popover/info-popover.component";
import { MaterialModule } from "src/app/app.materials";
import { LineChartComponent } from "src/app/components/line-chart/line-chart.component";
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UtcToLocalTimePipe } from "../../../shared/services/utc-to-local-time.pipe";
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-portfolio-list',
  templateUrl: './portfolio-list.component.html',
  styleUrls: ['./portfolio-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('100ms ease')),
    ]),
  ],
  imports: [InfoPopoverComponent, MaterialModule, LineChartComponent, FormsModule, RouterModule, UtcToLocalTimePipe, CommonModule],
  standalone: true,
})
export class PortfolioListComponent implements OnInit {
  @Input() list: any[] = [];
  @Input() readOnly = false;
  @Output() portfolioSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() forkPortfolio: EventEmitter<any> = new EventEmitter<any>();
  @Output() unsharePortfolio: EventEmitter<any> = new EventEmitter<any>();

  portfolioTypeNameList = portfolioTypes.map(t => t.name);
  sharedVisivility = VISIBILITY_SHARED;

  ytdOptions = {
    chart: {
      height: '140px'
    },
    legend: {
      enabled: false
    },
    navigator: {
      enabled: false
    },
    zoom: {
      enabled: false,
    },
    rangeSelector: {
      enabled:false
    },
    scrollbar: {
      enabled: false
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: 'Date',
        style: {
          textTransform: 'capitalize'
        }
      },
      labels: {
        enabled: false
      },
      minorGridLineWidth: 0,
      crosshair: {
        snap:false,
        color:'#c18b94',
        label: {
          formatter: function(e) {
            return moment(e).format('YYYY-MM-DD')
          },
          enabled: true
        }
      },
    },
    yAxis: {
      opposite: false,
      minorGridLineWidth: 0,
      labels: {
        enabled: false
      },
      title: {
        text: 'Return',
        style: {
          textTransform: 'capitalize'
        }
      }
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        dataGrouping: {
          enabled: false
        },
        label: {
          enabled: false,
        }
      }
    },
  }

  categories: any = {}
  sorting: any = null;
  sortOptions = [
    {
      id: 'name_asc',
      name: 'Name ASC',
      prop: 'name',
      dir: 'asc'
    },
    {
      id: 'name_desc',
      name: 'Name DESC',
      prop: 'name',
      dir: 'desc'
    },
    {
      id: 'risk_asc',
      name: 'Risk ASC',
      prop: 'risk',
      dir: 'asc'
    },
    {
      id: 'risk_desc',
      name: 'Risk DESC',
      prop: 'risk',
      dir: 'desc'
    },
    {
      id: 'return_asc',
      name: 'Return ASC',
      prop: 'return',
      dir: 'asc'
    },
    {
      id: 'return_desc',
      name: 'Return DESC',
      prop: 'return',
      dir: 'desc'
    },
    {
      id: 'created_at_desc',
      name: 'Newest',
      prop: 'created_at',
      dir: 'desc'
    }
  ];

  constructor(
    private service: PortfolioService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.list) {
      this.initCategories();
    }
  }

  sortList(sortObj) {
    const sortOrder = sortObj.dir === 'asc' ? 1 : -1;
    return (a, b) => {
      const result = (a[sortObj.prop] < b[sortObj.prop]) ? -1 : (a[sortObj.prop] > b[sortObj.prop]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  onSortingChange() {
    let sortObj = this.sorting || null;
    if (!sortObj) {
      sortObj = {
        id: 'id',
        prop: 'id',
        dir: 'asc'
      };
    }
    Object.entries(this.categories).map(([key, obj]: [string, any]) => {
      obj.list = obj.list.sort(this.sortList(sortObj));
    });
  }

  initCategories() {
    if (this.list.length) {
      this.categories = {};
      this.list.map((p: any) => {
        let typeName = this.portfolioTypeNameList[p.type];
        if (!this.categories[typeName]) {
          this.categories[typeName] = {
            list: [],
            expanded: false
          };
        }
        this.categories[typeName].list.push(p)
      })
    }

  }

  onStockClick(portfolio) {
    if (portfolio.status === 1) {
      return this.service.notificationService.open("Portfolio is not ready yet");
    }
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate(['/app/portfolio-view', portfolio.id]);
      if (this.readOnly) {
        // portfolio selected in the nav bar dialog, reload the page
        setTimeout(() => {
          window.location.reload();
        }, 200)
      }
    });
  }

  closeOtherInfo(element) {
    this.list = this.list.map((c: any) => {
      if (c.id !== element.id) {
        c.isOpen = false;
      }
      return c;
    });
  }

  openPortfolio(item) {
    this.service.viewItem(item.id).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error)
      }
      if (resp) {
        this.service.selectPortfolio(new PortfolioModel(resp));
        this.router.navigate(['/app/overview']);
        this.portfolioSelected.emit();
      }
    })
  }

  onClickCopy(item) {
    this.forkPortfolio.emit(item);
  }

  doDelete(item) {
    this.service.deleteItem(item).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error)
      }
      this.service.notificationService.open('Portfolio deleted')
      this.list = this.list.includes(item) ? this.list.filter(i => i !== item) : this.list;
    })
  }

  deleteItem(item) {
    this.service.confirmAction().subscribe(confirm => {
      if (confirm) {
        this.doDelete(item);
      }
    })
  }

  unshareItem(item) {
    this.unsharePortfolio.emit(item);
  }

  getTypeName(id) {
    return this.portfolioTypeNameList[id]
  }

}
